module.exports = __webpack_public_path__ + "img/logo_6.33d3381e.png";